// extracted by mini-css-extract-plugin
module.exports = {"root":"Editor_root__3aqMi","topBar":"Editor_topBar__2ifOf","prompts":"Editor_prompts__3eadY"};